// export const permission: Permission[] = [
//   {
//     id: 534,
//     name: 'Pode adicionar Acesso',
//     codename: 'de_can_add_access',
//     content_type: 77,
//   },
//   {
//     id: 546,
//     name: 'Pode adicionar Agentes',
//     codename: 'de_can_add_agents',
//     content_type: 77,
//   },
//   {
//     id: 506,
//     name: 'Pode adicionar Cedentes',
//     codename: 'de_can_add_assignor',
//     content_type: 77,
//   },
//   {
//     id: 558,
//     name: 'Pode adicionar Audiorias',
//     codename: 'de_can_add_audit',
//     content_type: 77,
//   },
//   {
//     id: 522,
//     name: 'Pode adicionar Colaboradores',
//     codename: 'de_can_add_collaborator',
//     content_type: 77,
//   },
//   {
//     id: 526,
//     name: 'Pode adicionar Configurações',
//     codename: 'de_can_add_configuration',
//     content_type: 77,
//   },
//   {
//     id: 566,
//     name: 'Pode adicionar Departamentos',
//     codename: 'de_can_add_departments',
//     content_type: 77,
//   },
//   {
//     id: 550,
//     name: 'Pode adicionar Documentos',
//     codename: 'de_can_add_documents',
//     content_type: 77,
//   },
//   {
//     id: 530,
//     name: 'Pode adicionar Minutas',
//     codename: 'de_can_add_draft',
//     content_type: 77,
//   },
//   {
//     id: 502,
//     name: 'Pode adicionar Fundos',
//     codename: 'de_can_add_fund',
//     content_type: 77,
//   },
//   {
//     id: 542,
//     name: 'Pode adicionar Convite',
//     codename: 'de_can_add_invite',
//     content_type: 77,
//   },
//   {
//     id: 514,
//     name: 'Pode adicionar Prestadores de Serviço',
//     codename: 'de_can_add_provider',
//     content_type: 77,
//   },
//   {
//     id: 518,
//     name: 'Pode adicionar Cadastros',
//     codename: 'de_can_add_register',
//     content_type: 77,
//   },
//   {
//     id: 538,
//     name: 'Pode adicionar Representantes',
//     codename: 'de_can_add_representative',
//     content_type: 77,
//   },
//   {
//     id: 510,
//     name: 'Pode adicionar Cotistas',
//     codename: 'de_can_add_shareholder',
//     content_type: 77,
//   },
//   {
//     id: 562,
//     name: 'Pode adicionar Testemunhas',
//     codename: 'de_can_add_witnesses',
//     content_type: 77,
//   },
//   {
//     id: 554,
//     name: 'Pode adicionar Fundos de zeragem',
//     codename: 'de_can_add_zeroing_fund',
//     content_type: 77,
//   },
//   {
//     id: 536,
//     name: 'Pode alterar Acesso',
//     codename: 'de_can_change_access',
//     content_type: 77,
//   },
//   {
//     id: 548,
//     name: 'Pode alterar Agentes',
//     codename: 'de_can_change_agents',
//     content_type: 77,
//   },
//   {
//     id: 508,
//     name: 'Pode alterar Cedentes',
//     codename: 'de_can_change_assignor',
//     content_type: 77,
//   },
//   {
//     id: 560,
//     name: 'Pode alterar Audiorias',
//     codename: 'de_can_change_audit',
//     content_type: 77,
//   },
//   {
//     id: 524,
//     name: 'Pode alterar Colaboradores',
//     codename: 'de_can_change_collaborator',
//     content_type: 77,
//   },
//   {
//     id: 528,
//     name: 'Pode alterar Configurações',
//     codename: 'de_can_change_configuration',
//     content_type: 77,
//   },
//   {
//     id: 568,
//     name: 'Pode alterar Departamentos',
//     codename: 'de_can_change_departments',
//     content_type: 77,
//   },
//   {
//     id: 552,
//     name: 'Pode alterar Documentos',
//     codename: 'de_can_change_documents',
//     content_type: 77,
//   },
//   {
//     id: 532,
//     name: 'Pode alterar Minutas',
//     codename: 'de_can_change_draft',
//     content_type: 77,
//   },
//   {
//     id: 504,
//     name: 'Pode alterar Fundos',
//     codename: 'de_can_change_fund',
//     content_type: 77,
//   },
//   {
//     id: 544,
//     name: 'Pode alterar Convite',
//     codename: 'de_can_change_invite',
//     content_type: 77,
//   },
//   {
//     id: 516,
//     name: 'Pode alterar Prestadores de Serviço',
//     codename: 'de_can_change_provider',
//     content_type: 77,
//   },
//   {
//     id: 520,
//     name: 'Pode alterar Cadastros',
//     codename: 'de_can_change_register',
//     content_type: 77,
//   },
//   {
//     id: 540,
//     name: 'Pode alterar Representantes',
//     codename: 'de_can_change_representative',
//     content_type: 77,
//   },
//   {
//     id: 512,
//     name: 'Pode alterar Cotistas',
//     codename: 'de_can_change_shareholder',
//     content_type: 77,
//   },
//   {
//     id: 564,
//     name: 'Pode alterar Testemunhas',
//     codename: 'de_can_change_witnesses',
//     content_type: 77,
//   },
//   {
//     id: 556,
//     name: 'Pode alterar Fundos de zeragem',
//     codename: 'de_can_change_zeroing_fund',
//     content_type: 77,
//   },
//   {
//     id: 537,
//     name: 'Pode deletar Acesso',
//     codename: 'de_can_delete_access',
//     content_type: 77,
//   },
//   {
//     id: 549,
//     name: 'Pode deletar Agentes',
//     codename: 'de_can_delete_agents',
//     content_type: 77,
//   },
//   {
//     id: 509,
//     name: 'Pode deletar Cedentes',
//     codename: 'de_can_delete_assignor',
//     content_type: 77,
//   },
//   {
//     id: 561,
//     name: 'Pode deletar Audiorias',
//     codename: 'de_can_delete_audit',
//     content_type: 77,
//   },
//   {
//     id: 525,
//     name: 'Pode deletar Colaboradores',
//     codename: 'de_can_delete_collaborator',
//     content_type: 77,
//   },
//   {
//     id: 529,
//     name: 'Pode deletar Configurações',
//     codename: 'de_can_delete_configuration',
//     content_type: 77,
//   },
//   {
//     id: 569,
//     name: 'Pode deletar Departamentos',
//     codename: 'de_can_remove_departments',
//     content_type: 77,
//   },
//   {
//     id: 553,
//     name: 'Pode deletar Documentos',
//     codename: 'de_can_delete_documents',
//     content_type: 77,
//   },
//   {
//     id: 533,
//     name: 'Pode deletar Minutas',
//     codename: 'de_can_delete_draft',
//     content_type: 77,
//   },
//   {
//     id: 505,
//     name: 'Pode deletar Fundos',
//     codename: 'de_can_delete_fund',
//     content_type: 77,
//   },
//   {
//     id: 545,
//     name: 'Pode deletar Convite',
//     codename: 'de_can_delete_invite',
//     content_type: 77,
//   },
//   {
//     id: 517,
//     name: 'Pode deletar Prestadores de Serviço',
//     codename: 'de_can_delete_provider',
//     content_type: 77,
//   },
//   {
//     id: 521,
//     name: 'Pode deletar Cadastros',
//     codename: 'de_can_delete_register',
//     content_type: 77,
//   },
//   {
//     id: 541,
//     name: 'Pode deletar Representantes',
//     codename: 'de_can_delete_representative',
//     content_type: 77,
//   },
//   {
//     id: 513,
//     name: 'Pode deletar Cotistas',
//     codename: 'de_can_delete_shareholder',
//     content_type: 77,
//   },
//   {
//     id: 565,
//     name: 'Pode deletar Testemunhas',
//     codename: 'de_can_delete_witnesses',
//     content_type: 77,
//   },
//   {
//     id: 557,
//     name: 'Pode deletar Fundos de zeragem',
//     codename: 'de_can_delete_zeroing_fund',
//     content_type: 77,
//   },
//   {
//     id: 5355,
//     name: 'Pode visualizar Minha Área',
//     codename: 'de_can_view_my_area',
//     content_type: 77,
//   },
//   {
//     id: 5355,
//     name: 'Pode visualizar Meus Registros',
//     codename: 'de_can_view_my_registers',
//     content_type: 77,
//   },
//   {
//     id: 535,
//     name: 'Pode visualizar Acesso',
//     codename: 'de_can_view_access',
//     content_type: 77,
//   },
//   {
//     id: 547,
//     name: 'Pode visualizar Agentes',
//     codename: 'de_can_view_agents',
//     content_type: 77,
//   },
//   {
//     id: 507,
//     name: 'Pode visualizar Cedentes',
//     codename: 'de_can_view_assignor',
//     content_type: 77,
//   },
//   {
//     id: 559,
//     name: 'Pode visualizar Audiorias',
//     codename: 'de_can_view_audit',
//     content_type: 77,
//   },
//   {
//     id: 523,
//     name: 'Pode visualizar Colaboradores',
//     codename: 'de_can_view_collaborator',
//     content_type: 77,
//   },
//   {
//     id: 527,
//     name: 'Pode visualizar Configurações',
//     codename: 'de_can_view_configuration',
//     content_type: 77,
//   },
//   {
//     id: 567,
//     name: 'Pode visualizar Departamentos',
//     codename: 'de_can_view_departments',
//     content_type: 77,
//   },
//   {
//     id: 551,
//     name: 'Pode visualizar Documentos',
//     codename: 'de_can_view_documents',
//     content_type: 77,
//   },
//   {
//     id: 531,
//     name: 'Pode visualizar Minutas',
//     codename: 'de_can_view_draft',
//     content_type: 77,
//   },
//   {
//     id: 503,
//     name: 'Pode visualizar Fundos',
//     codename: 'de_can_view_fund',
//     content_type: 77,
//   },
//   {
//     id: 543,
//     name: 'Pode visualizar Convite',
//     codename: 'de_can_view_invites',
//     content_type: 77,
//   },
//   {
//     id: 515,
//     name: 'Pode visualizar Prestadores de Serviço',
//     codename: 'de_can_view_provider',
//     content_type: 77,
//   },
//   {
//     id: 519,
//     name: 'Pode visualizar Cadastros',
//     codename: 'de_can_view_registers',
//     content_type: 77,
//   },
//   {
//     id: 539,
//     name: 'Pode visualizar Representantes',
//     codename: 'de_can_view_representative',
//     content_type: 77,
//   },
//   {
//     id: 511,
//     name: 'Pode visualizar Cotistas',
//     codename: 'de_can_view_shareholder',
//     content_type: 77,
//   },
//   {
//     id: 563,
//     name: 'Pode visualizar Testemunhas',
//     codename: 'de_can_view_witnesses',
//     content_type: 77,
//   },
//   {
//     id: 555,
//     name: 'Pode visualizar Fundos de zeragem',
//     codename: 'de_can_view_zeroing_fund',
//     content_type: 77,
//   },
//   {
//     id: 1000,
//     name: 'Pode visualizar grupos de permissão',
//     codename: 'de_can_view_group_permission',
//     content_type: 77,
//   },
//   {
//     id: 1001,
//     name: 'Pode adicionar grupos de permissão',
//     codename: 'de_can_add_group_permission',
//     content_type: 77,
//   },
//   {
//     id: 1002,
//     name: 'Pode editar grupos de permissão',
//     codename: 'de_can_change_group_permission',
//     content_type: 77,
//   },
//   {
//     id: 1003,
//     name: 'Pode deletar grupos de permissão',
//     codename: 'de_can_delete_group_permission',
//     content_type: 77,
//   },
//   {
//     id: 1004,
//     name: 'Pode visualizar grupos de usuários',
//     codename: 'de_can_view_user_group',
//     content_type: 77,
//   },
//   {
//     id: 1005,
//     name: 'Pode adicionar grupos de usuários',
//     codename: 'de_can_add_user_group',
//     content_type: 77,
//   },
//   {
//     id: 1006,
//     name: 'Pode editar grupos de usuários',
//     codename: 'de_can_change_user_group',
//     content_type: 77,
//   },
//   {
//     id: 1007,
//     name: 'Pode editar usuários',
//     codename: 'de_can_change_user_group_user',
//     content_type: 77,
//   },
//   {
//     id: 1008,
//     name: 'Pode deletar usuários',
//     codename: 'de_can_delete_user_group_user',
//     content_type: 77,
//   },

//   {
//     id: 1009,
//     name: 'Pode visualizar empresa',
//     codename: 'de_can_view_user_group_company',
//     content_type: 77,
//   },
//   {
//     id: 10010,
//     name: 'Pode adicionar empresa',
//     codename: 'de_can_add_user_group_company',
//     content_type: 77,
//   },
//   {
//     id: 10011,
//     name: 'Pode editar empresa',
//     codename: 'de_can_change_user_group_company',
//     content_type: 77,
//   },
//   {
//     id: 10012,
//     name: 'Pode deletar empresa',
//     codename: 'de_can_delete_user_group_company',
//     content_type: 77,
//   },

//   {
//     id: 10013,
//     name: 'Pode visualizar histórico',
//     codename: 'de_can_view_permission_history',
//     content_type: 77,
//   },
//   {
//     id: 10014,
//     name: 'Pode adicionar histórico',
//     codename: 'de_can_add_permission_history',
//     content_type: 77,
//   },
//   {
//     id: 10015,
//     name: 'Pode editar histórico',
//     codename: 'de_can_change_permission_history',
//     content_type: 77,
//   },
//   {
//     id: 10016,
//     name: 'Pode deletar histórico',
//     codename: 'de_can_delete_permission_history',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_delete_user_group',
//     id: 10017,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_add_user_group',
//     id: 10018,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_view_user_group',
//     id: 10019,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_change_user_group',
//     id: 10020,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_add_permission_history',
//     id: 10021,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_delete_permission_history',
//     id: 10022,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_change_permission_history',
//     id: 10023,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_view_permission_history',
//     id: 10024,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_change_user_group_user',
//     id: 10025,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_add_user_group_user',
//     id: 10026,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_view_user_group_user',
//     id: 10027,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     codename: 'de_can_delete_user_group_user',
//     id: 10028,
//     name: 'teste',
//     content_type: 77,
//   },
//   {
//     id: 559,
//     name: 'Add companies',
//     codename: 'de_can_add_companies',
//     content_type: 77,
//   },
//   {
//     id: 560,
//     name: 'Add company departments',
//     codename: 'de_can_add_company_departments',
//     content_type: 77,
//   },
//   {
//     id: 561,
//     name: 'Add company details profiles',
//     codename: 'de_can_add_company_details_profiles',
//     content_type: 77,
//   },
//   {
//     id: 562,
//     name: 'Add company groups',
//     codename: 'de_can_add_company_groups',
//     content_type: 77,
//   },
//   {
//     id: 563,
//     name: 'Add company profiles',
//     codename: 'de_can_add_company_profiles',
//     content_type: 77,
//   },
//   {
//     id: 564,
//     name: 'Add company users',
//     codename: 'de_can_add_company_users',
//     content_type: 77,
//   },
//   {
//     id: 565,
//     name: 'Add groups',
//     codename: 'de_can_add_groups',
//     content_type: 77,
//   },
//   {
//     id: 566,
//     name: 'Add permissions',
//     codename: 'de_can_add_permissions',
//     content_type: 77,
//   },
//   {
//     id: 567,
//     name: 'Add invites',
//     codename: 'de_can_add_invites',
//     content_type: 77,
//   },
//   {
//     id: 568,
//     name: 'Add invites assignor',
//     codename: 'de_can_add_invites_assignor',
//     content_type: 77,
//   },
//   {
//     id: 569,
//     name: 'Add invites provider',
//     codename: 'de_can_add_invites_provider',
//     content_type: 77,
//   },
//   {
//     id: 570,
//     name: 'Add invites shareholder',
//     codename: 'de_can_add_invites_shareholder',
//     content_type: 77,
//   },
//   {
//     id: 571,
//     name: 'Approve assignor',
//     codename: 'de_can_approve_assignor',
//     content_type: 77,
//   },
//   {
//     id: 572,
//     name: 'Approve fund',
//     codename: 'de_can_approve_fund',
//     content_type: 77,
//   },
//   {
//     id: 573,
//     name: 'Approve provider',
//     codename: 'de_can_approve_provider',
//     content_type: 77,
//   },
//   {
//     id: 574,
//     name: 'Approve shareholder',
//     codename: 'de_can_approve_shareholder',
//     content_type: 77,
//   },
//   {
//     id: 575,
//     name: 'Change company departments',
//     codename: 'de_can_change_company_departments',
//     content_type: 77,
//   },
//   {
//     id: 576,
//     name: 'Change company users',
//     codename: 'de_can_change_company_users',
//     content_type: 77,
//   },
//   {
//     id: 577,
//     name: 'Change groups',
//     codename: 'de_can_change_groups',
//     content_type: 77,
//   },
//   {
//     id: 578,
//     name: 'Change invites',
//     codename: 'de_can_change_invites',
//     content_type: 77,
//   },
//   {
//     id: 579,
//     name: 'Change permissions',
//     codename: 'de_can_change_permissions',
//     content_type: 77,
//   },
//   {
//     id: 580,
//     name: 'Filter companies',
//     codename: 'de_can_filter_companies',
//     content_type: 77,
//   },
//   {
//     id: 581,
//     name: 'Filter company departments',
//     codename: 'de_can_filter_company_departments',
//     content_type: 77,
//   },
//   {
//     id: 582,
//     name: 'Filter company details profiles',
//     codename: 'de_can_filter_company_details_profiles',
//     content_type: 77,
//   },
//   {
//     id: 583,
//     name: 'Filter company profiles',
//     codename: 'de_can_filter_company_profiles',
//     content_type: 77,
//   },
//   {
//     id: 584,
//     name: 'Filter company users',
//     codename: 'de_can_filter_company_users',
//     content_type: 77,
//   },
//   {
//     id: 585,
//     name: 'Filter draft',
//     codename: 'de_can_filter_draft',
//     content_type: 77,
//   },
//   {
//     id: 586,
//     name: 'Filter fund',
//     codename: 'de_can_filter_fund',
//     content_type: 77,
//   },
//   {
//     id: 587,
//     name: 'Filter groups',
//     codename: 'de_can_filter_groups',
//     content_type: 77,
//   },
//   {
//     id: 588,
//     name: 'Filter invites',
//     codename: 'de_can_filter_invites',
//     content_type: 77,
//   },
//   {
//     id: 589,
//     name: 'Filter permissions',
//     codename: 'de_can_filter_permissions',
//     content_type: 77,
//   },
//   {
//     id: 590,
//     name: 'Filter registers',
//     codename: 'de_can_filter_registers',
//     content_type: 77,
//   },
//   {
//     id: 591,
//     name: 'Inactive companies',
//     codename: 'de_can_inactive_companies',
//     content_type: 77,
//   },
//   {
//     id: 592,
//     name: 'Inactive company groups',
//     codename: 'de_can_inactive_company_groups',
//     content_type: 77,
//   },
//   {
//     id: 593,
//     name: 'Inactive company users',
//     codename: 'de_can_inactive_company_users',
//     content_type: 77,
//   },
//   {
//     id: 594,
//     name: 'Inactive groups',
//     codename: 'de_can_inactive_groups',
//     content_type: 77,
//   },
//   {
//     id: 595,
//     name: 'Inactive permissions',
//     codename: 'de_can_inactive_permissions',
//     content_type: 77,
//   },
//   {
//     id: 596,
//     name: 'Remove invites',
//     codename: 'de_can_remove_invites',
//     content_type: 77,
//   },
//   {
//     id: 597,
//     name: 'Return assignor',
//     codename: 'de_can_return_assignor',
//     content_type: 77,
//   },
//   {
//     id: 598,
//     name: 'Return fund',
//     codename: 'de_can_return_fund',
//     content_type: 77,
//   },
//   {
//     id: 599,
//     name: 'Return provider',
//     codename: 'de_can_return_provider',
//     content_type: 77,
//   },
//   {
//     id: 600,
//     name: 'Return shareholder',
//     codename: 'de_can_return_shareholder',
//     content_type: 77,
//   },
//   {
//     id: 10029,
//     name: 'Pode alterar assignor details',
//     codename: 'de_can_change_assignor_details',
//     content_type: 77,
//   },
//   {
//     id: 10030,
//     name: 'Pode alterar provider details',
//     codename: 'de_can_change_provider_details',
//     content_type: 77,
//   },
//   {
//     id: 10031,
//     name: 'Pode alterar shareholder details',
//     codename: 'de_can_change_shareholder_details',
//     content_type: 77,
//   },
//   {
//     id: 10032,
//     name: 'Pode visualizar assignor details',
//     codename: 'de_can_view_assignor_details',
//     content_type: 77,
//   },
//   {
//     id: 10033,
//     name: 'Pode visualizar details invite',
//     codename: 'de_can_view_details_invites',
//     content_type: 77,
//   },
// ];

// permissions.ts

export const permission = [
  {
    id: 1,
    name: 'View my registers',
    codename: 'de_can_view_my_registers',
    content_type: 77,
  },
  {
    id: 2,
    name: 'Filter my registers',
    codename: 'de_can_filter_my_registers',
    content_type: 77,
  },
  {
    id: 3,
    name: 'View assignor',
    codename: 'de_can_view_assignor',
    content_type: 77,
  },
  {
    id: 4,
    name: 'View shareholder',
    codename: 'de_can_view_shareholder',
    content_type: 77,
  },
  {
    id: 5,
    name: 'View provider',
    codename: 'de_can_view_provider',
    content_type: 77,
  },
  {
    id: 6,
    name: 'Change assignor',
    codename: 'de_can_change_assignor',
    content_type: 77,
  },
  {
    id: 7,
    name: 'Change shareholder',
    codename: 'de_can_change_shareholder',
    content_type: 77,
  },
  {
    id: 8,
    name: 'Change provider',
    codename: 'de_can_change_provider',
    content_type: 77,
  },
  {
    id: 9,
    name: 'View invites',
    codename: 'de_can_view_invites',
    content_type: 77,
  },
  {
    id: 10,
    name: 'Filter invites',
    codename: 'de_can_filter_invites',
    content_type: 77,
  },
  {
    id: 11,
    name: 'View invite details',
    codename: 'de_can_view_details_invite',
    content_type: 77,
  },
  {
    id: 12,
    name: 'Change invites',
    codename: 'de_can_change_invites',
    content_type: 77,
  },
  {
    id: 13,
    name: 'Remove invites',
    codename: 'de_can_remove_invites',
    content_type: 77,
  },
  {
    id: 14,
    name: 'Add invites',
    codename: 'de_can_add_invites',
    content_type: 77,
  },
  {
    id: 15,
    name: 'Add invites assignor',
    codename: 'de_can_add_invites_assignor',
    content_type: 77,
  },
  {
    id: 16,
    name: 'Add invites provider',
    codename: 'de_can_add_invites_provider',
    content_type: 77,
  },
  {
    id: 17,
    name: 'Add invites shareholder',
    codename: 'de_can_add_invites_shareholder',
    content_type: 77,
  },
  {
    id: 18,
    name: 'View access',
    codename: 'de_can_view_access',
    content_type: 77,
  },
  {
    id: 19,
    name: 'Add access',
    codename: 'de_can_add_access',
    content_type: 77,
  },
  {
    id: 20,
    name: 'View registers',
    codename: 'de_can_view_registers',
    content_type: 77,
  },
  {
    id: 21,
    name: 'Filter registers',
    codename: 'de_can_filter_registers',
    content_type: 77,
  },
  {
    id: 22,
    name: 'View assignor details',
    codename: 'de_can_view_assignor_details',
    content_type: 77,
  },
  {
    id: 23,
    name: 'View provider details',
    codename: 'de_can_view_provider_details',
    content_type: 77,
  },
  {
    id: 24,
    name: 'View shareholder details',
    codename: 'de_can_view_shareholder_details',
    content_type: 77,
  },
  {
    id: 25,
    name: 'Change assignor details',
    codename: 'de_can_change_assignor_details',
    content_type: 77,
  },
  {
    id: 26,
    name: 'Change provider details',
    codename: 'de_can_change_provider_details',
    content_type: 77,
  },
  {
    id: 27,
    name: 'Change shareholder details',
    codename: 'de_can_change_shareholder_details',
    content_type: 77,
  },
  { id: 28, name: 'View fund', codename: 'de_can_view_fund', content_type: 77 },
  {
    id: 29,
    name: 'Filter fund',
    codename: 'de_can_filter_fund',
    content_type: 77,
  },
  {
    id: 30,
    name: 'Change fund',
    codename: 'de_can_change_fund',
    content_type: 77,
  },
  { id: 31, name: 'View fund', codename: 'de_can_view_fund', content_type: 77 },
  {
    id: 32,
    name: 'View collaborator',
    codename: 'de_can_view_collaborator',
    content_type: 77,
  },
  {
    id: 33,
    name: 'View departments',
    codename: 'de_can_view_departments',
    content_type: 77,
  },
  {
    id: 34,
    name: 'Change departments',
    codename: 'de_can_change_departments',
    content_type: 77,
  },
  {
    id: 35,
    name: 'Remove departments',
    codename: 'de_can_remove_departments',
    content_type: 77,
  },
  {
    id: 36,
    name: 'Add departments',
    codename: 'de_can_add_departments',
    content_type: 77,
  },
  {
    id: 37,
    name: 'Change collaborator',
    codename: 'de_can_change_collaborator',
    content_type: 77,
  },
  {
    id: 38,
    name: 'Remove collaborator',
    codename: 'de_can_remove_collaborator',
    content_type: 77,
  },
  {
    id: 39,
    name: 'Add collaborator',
    codename: 'de_can_add_collaborator',
    content_type: 77,
  },
  {
    id: 40,
    name: 'View witnesses',
    codename: 'de_can_view_witnesses',
    content_type: 77,
  },
  {
    id: 41,
    name: 'Change witnesses',
    codename: 'de_can_change_witnesses',
    content_type: 77,
  },
  {
    id: 42,
    name: 'Remove witnesses',
    codename: 'de_can_remove_witnesses',
    content_type: 77,
  },
  {
    id: 43,
    name: 'Add witnesses',
    codename: 'de_can_add_witnesses',
    content_type: 77,
  },
  {
    id: 44,
    name: 'View configurations',
    codename: 'de_can_view_configurations',
    content_type: 77,
  },
  {
    id: 45,
    name: 'View agents',
    codename: 'de_can_view_agents',
    content_type: 77,
  },
  {
    id: 46,
    name: 'Add agents',
    codename: 'de_can_add_agents',
    content_type: 77,
  },
  {
    id: 47,
    name: 'Change agents',
    codename: 'de_can_change_agents',
    content_type: 77,
  },
  {
    id: 48,
    name: 'Remove agents',
    codename: 'de_can_remove_agents',
    content_type: 77,
  },
  {
    id: 49,
    name: 'View documents',
    codename: 'de_can_view_documents',
    content_type: 77,
  },
  {
    id: 50,
    name: 'Add documents',
    codename: 'de_can_add_documents',
    content_type: 77,
  },
  {
    id: 51,
    name: 'Change documents',
    codename: 'de_can_change_documents',
    content_type: 77,
  },
  {
    id: 52,
    name: 'Remove documents',
    codename: 'de_can_remove_documents',
    content_type: 77,
  },
  {
    id: 53,
    name: 'View zeroing fund',
    codename: 'de_can_view_zeroing_fund',
    content_type: 77,
  },
  {
    id: 54,
    name: 'Add zeroing fund',
    codename: 'de_can_add_zeroing_fund',
    content_type: 77,
  },
  {
    id: 55,
    name: 'Change zeroing fund',
    codename: 'de_can_change_zeroing_fund',
    content_type: 77,
  },
  {
    id: 56,
    name: 'Remove zeroing fund',
    codename: 'de_can_remove_zeroing_fund',
    content_type: 77,
  },
  {
    id: 57,
    name: 'View audit',
    codename: 'de_can_view_audit',
    content_type: 77,
  },
  { id: 58, name: 'Add audit', codename: 'de_can_add_audit', content_type: 77 },
  {
    id: 59,
    name: 'Change audit',
    codename: 'de_can_change_audit',
    content_type: 77,
  },
  {
    id: 60,
    name: 'Remove audit',
    codename: 'de_can_remove_audit',
    content_type: 77,
  },
  {
    id: 61,
    name: 'View draft',
    codename: 'de_can_view_draft',
    content_type: 77,
  },
  {
    id: 62,
    name: 'Filter draft',
    codename: 'de_can_filter_draft',
    content_type: 77,
  },
  { id: 63, name: 'Add draft', codename: 'de_can_add_draft', content_type: 77 },
  {
    id: 64,
    name: 'Change draft',
    codename: 'de_can_change_draft',
    content_type: 77,
  },
  {
    id: 65,
    name: 'Remove draft',
    codename: 'de_can_remove_draft',
    content_type: 77,
  },
  {
    id: 66,
    name: 'View fund basic data',
    codename: 'de_can_view_fund_basic_data',
    content_type: 77,
  },
  {
    id: 67,
    name: 'View fund transfer',
    codename: 'de_can_view_fund_transfer',
    content_type: 77,
  },
  {
    id: 68,
    name: 'View fund complementary',
    codename: 'de_can_view_fund_complementary',
    content_type: 77,
  },
  {
    id: 69,
    name: 'View fund quote',
    codename: 'de_can_view_fund_quote',
    content_type: 77,
  },
  {
    id: 70,
    name: 'View fund quote details',
    codename: 'de_can_view_fund_quote_details',
    content_type: 77,
  },
  {
    id: 71,
    name: 'View fund provider',
    codename: 'de_can_view_fund_provider',
    content_type: 77,
  },
  {
    id: 72,
    name: 'View fund provider details',
    codename: 'de_can_view_fund_provider_details',
    content_type: 77,
  },
  {
    id: 73,
    name: 'View fund tax',
    codename: 'de_can_view_fund_tax',
    content_type: 77,
  },
  {
    id: 74,
    name: 'View fund bank',
    codename: 'de_can_view_fund_bank',
    content_type: 77,
  },
  {
    id: 75,
    name: 'View fund files',
    codename: 'de_can_view_fund_files',
    content_type: 77,
  },
  {
    id: 76,
    name: 'View fund files details',
    codename: 'de_can_view_fund_files_details',
    content_type: 77,
  },
  {
    id: 77,
    name: 'Add fund files',
    codename: 'de_can_view_fund_files_add',
    content_type: 77,
  },
  {
    id: 78,
    name: 'View fund history',
    codename: 'de_can_view_fund_history',
    content_type: 77,
  },
  {
    id: 79,
    name: 'View fund draft',
    codename: 'de_can_view_fund_draft',
    content_type: 77,
  },
  {
    id: 80,
    name: 'View fund draft details',
    codename: 'de_can_view_fund_draft_details',
    content_type: 77,
  },
  {
    id: 81,
    name: 'Add fund draft',
    codename: 'de_can_view_fund_draft_add',
    content_type: 77,
  },
  {
    id: 82,
    name: 'View fund assignors',
    codename: 'de_can_view_fund_assignors',
    content_type: 77,
  },
  {
    id: 83,
    name: 'View fund assignors details',
    codename: 'de_can_view_fund_assignors_details',
    content_type: 77,
  },
  {
    id: 84,
    name: 'View fund shareholder',
    codename: 'de_can_view_fund_shareholder',
    content_type: 77,
  },
  {
    id: 85,
    name: 'View fund shareholder details',
    codename: 'de_can_view_fund_shareholder_details',
    content_type: 77,
  },
  {
    id: 86,
    name: 'Approve fund',
    codename: 'de_can_approve_fund',
    content_type: 77,
  },
  {
    id: 87,
    name: 'Reject fund',
    codename: 'de_can_reject_fund',
    content_type: 77,
  },
  {
    id: 88,
    name: 'Return fund',
    codename: 'de_can_return_fund',
    content_type: 77,
  },
  {
    id: 89,
    name: 'View provider complementary',
    codename: 'de_can_view_provider_complementary',
    content_type: 77,
  },
  {
    id: 90,
    name: 'View provider composition',
    codename: 'de_can_view_provider_composition',
    content_type: 77,
  },
  {
    id: 91,
    name: 'View provider representatives',
    codename: 'de_can_view_provider_representatives',
    content_type: 77,
  },
  {
    id: 92,
    name: 'View provider representatives details',
    codename: 'de_can_view_provider_representatives_details',
    content_type: 77,
  },
  {
    id: 93,
    name: 'View provider powers',
    codename: 'de_can_view_provider_powers',
    content_type: 77,
  },
  {
    id: 94,
    name: 'View provider powers details',
    codename: 'de_can_view_provider_powers_details',
    content_type: 77,
  },
  {
    id: 95,
    name: 'View provider attachments',
    codename: 'de_can_view_provider_attachments',
    content_type: 77,
  },
  {
    id: 96,
    name: 'View provider attachments details',
    codename: 'de_can_view_provider_attachments_details',
    content_type: 77,
  },
  {
    id: 97,
    name: 'View provider history',
    codename: 'de_can_view_provider_history',
    content_type: 77,
  },
  {
    id: 98,
    name: 'View provider signs',
    codename: 'de_can_view_provider_signs',
    content_type: 77,
  },
  {
    id: 99,
    name: 'View provider funds',
    codename: 'de_can_view_provider_funds',
    content_type: 77,
  },
  {
    id: 100,
    name: 'View provider draft',
    codename: 'de_can_view_provider_draft',
    content_type: 77,
  },
  {
    id: 101,
    name: 'View provider draft details',
    codename: 'de_can_view_provider_draft_details',
    content_type: 77,
  },
  {
    id: 102,
    name: 'Add provider draft',
    codename: 'de_can_view_provider_draft_add',
    content_type: 77,
  },
  {
    id: 103,
    name: 'View provider documents',
    codename: 'de_can_view_provider_documents',
    content_type: 77,
  },
  {
    id: 104,
    name: 'Add provider documents',
    codename: 'de_can_view_provider_documents_add',
    content_type: 77,
  },
  {
    id: 105,
    name: 'Generate provider documents',
    codename: 'de_can_view_provider_documents_generate',
    content_type: 77,
  },
  {
    id: 106,
    name: 'View provider professional',
    codename: 'de_can_view_provider_professional',
    content_type: 77,
  },
  {
    id: 107,
    name: 'Approve provider',
    codename: 'de_can_approve_provider',
    content_type: 77,
  },
  {
    id: 108,
    name: 'Reject provider',
    codename: 'de_can_reject_provider',
    content_type: 77,
  },
  {
    id: 109,
    name: 'Return provider',
    codename: 'de_can_return_provider',
    content_type: 77,
  },
  {
    id: 110,
    name: 'View assignor',
    codename: 'de_can_view_assignor',
    content_type: 77,
  },
  {
    id: 111,
    name: 'View assignor complementary',
    codename: 'de_can_view_assignor_complementary',
    content_type: 77,
  },
  {
    id: 112,
    name: 'View assignor professional',
    codename: 'de_can_view_assignor_professional',
    content_type: 77,
  },
  {
    id: 113,
    name: 'View assignor representatives',
    codename: 'de_can_view_assignor_representatives',
    content_type: 77,
  },
  {
    id: 114,
    name: 'View assignor representatives details',
    codename: 'de_can_view_assignor_representatives_details',
    content_type: 77,
  },
  {
    id: 115,
    name: 'View assignor powers',
    codename: 'de_can_view_assignor_powers',
    content_type: 77,
  },
  {
    id: 116,
    name: 'View assignor powers details',
    codename: 'de_can_view_assignor_powers_details',
    content_type: 77,
  },
  {
    id: 117,
    name: 'View assignor attachments',
    codename: 'de_can_view_assignor_attachments',
    content_type: 77,
  },
  {
    id: 118,
    name: 'View assignor attachments details',
    codename: 'de_can_view_assignor_attachments_details',
    content_type: 77,
  },
  {
    id: 119,
    name: 'View assignor history',
    codename: 'de_can_view_assignor_history',
    content_type: 77,
  },
  {
    id: 120,
    name: 'View assignor signs',
    codename: 'de_can_view_assignor_signs',
    content_type: 77,
  },
  {
    id: 121,
    name: 'View assignor funds',
    codename: 'de_can_view_assignor_funds',
    content_type: 77,
  },
  {
    id: 122,
    name: 'View assignor draft details',
    codename: 'de_can_view_assignor_draft_details',
    content_type: 77,
  },
  {
    id: 123,
    name: 'Add assignor draft',
    codename: 'de_can_view_assignor_draft_add',
    content_type: 77,
  },
  {
    id: 124,
    name: 'View assignor documents',
    codename: 'de_can_view_assignor_documents',
    content_type: 77,
  },
  {
    id: 125,
    name: 'Add assignor documents',
    codename: 'de_can_view_assignor_documents_add',
    content_type: 77,
  },
  {
    id: 126,
    name: 'Generate assignor documents',
    codename: 'de_can_view_assignor_documents_generate',
    content_type: 77,
  },
  {
    id: 127,
    name: 'View assignor composition',
    codename: 'de_can_view_assignor_composition',
    content_type: 77,
  },
  {
    id: 128,
    name: 'Change assignor',
    codename: 'de_can_change_assignor',
    content_type: 77,
  },
  {
    id: 129,
    name: 'Approve assignor',
    codename: 'de_can_approve_assignor',
    content_type: 77,
  },
  {
    id: 130,
    name: 'Reject assignor',
    codename: 'de_can_reject_assignor',
    content_type: 77,
  },
  {
    id: 131,
    name: 'Return assignor',
    codename: 'de_can_return_assignor',
    content_type: 77,
  },

  {
    id: 132,
    name: 'View shareholder',
    codename: 'de_can_view_shareholder',
    content_type: 77,
  },
  {
    id: 133,
    name: 'View shareholder complementary',
    codename: 'de_can_view_shareholder_complementary',
    content_type: 77,
  },
  {
    id: 134,
    name: 'View shareholder risk',
    codename: 'de_can_view_shareholder_risk',
    content_type: 77,
  },
  {
    id: 135,
    name: 'View shareholder declarations',
    codename: 'de_can_view_shareholder_declarations',
    content_type: 77,
  },
  {
    id: 136,
    name: 'View shareholder providers',
    codename: 'de_can_view_shareholder_providers',
    content_type: 77,
  },
  {
    id: 137,
    name: 'View shareholder providers details',
    codename: 'de_can_view_shareholder_providers_details',
    content_type: 77,
  },
  {
    id: 138,
    name: 'View shareholder attachments',
    codename: 'de_can_view_shareholder_attachments',
    content_type: 77,
  },
  {
    id: 139,
    name: 'View shareholder attachments details',
    codename: 'de_can_view_shareholder_attachments_details',
    content_type: 77,
  },
  {
    id: 140,
    name: 'View shareholder history',
    codename: 'de_can_view_shareholder_history',
    content_type: 77,
  },
  {
    id: 141,
    name: 'View shareholder signs',
    codename: 'de_can_view_shareholder_signs',
    content_type: 77,
  },
  {
    id: 142,
    name: 'View shareholder funds',
    codename: 'de_can_view_shareholder_funds',
    content_type: 77,
  },
  {
    id: 143,
    name: 'View shareholder draft',
    codename: 'de_can_view_shareholder_draft',
    content_type: 77,
  },
  {
    id: 144,
    name: 'View shareholder draft details',
    codename: 'de_can_view_shareholder_draft_details',
    content_type: 77,
  },
  {
    id: 145,
    name: 'Add shareholder draft',
    codename: 'de_can_view_shareholder_draft_add',
    content_type: 77,
  },
  {
    id: 146,
    name: 'View shareholder documents',
    codename: 'de_can_view_shareholder_documents',
    content_type: 77,
  },
  {
    id: 147,
    name: 'Add shareholder documents',
    codename: 'de_can_view_shareholder_documents_add',
    content_type: 77,
  },
  {
    id: 148,
    name: 'Generate shareholder documents',
    codename: 'de_can_view_shareholder_documents_generate',
    content_type: 77,
  },
  {
    id: 149,
    name: 'View shareholder income',
    codename: 'de_can_view_shareholder_income',
    content_type: 77,
  },
  {
    id: 150,
    name: 'View shareholder representatives',
    codename: 'de_can_view_shareholder_representatives',
    content_type: 77,
  },
  {
    id: 151,
    name: 'View shareholder representatives details',
    codename: 'de_can_view_shareholder_representatives_details',
    content_type: 77,
  },
  {
    id: 152,
    name: 'View shareholder professional',
    codename: 'de_can_view_shareholder_professional',
    content_type: 77,
  },
  {
    id: 153,
    name: 'View shareholder powers',
    codename: 'de_can_view_shareholder_powers',
    content_type: 77,
  },
  {
    id: 154,
    name: 'View shareholder powers details',
    codename: 'de_can_view_shareholder_powers_details',
    content_type: 77,
  },
  {
    id: 155,
    name: 'View shareholder composition',
    codename: 'de_can_view_shareholder_composition',
    content_type: 77,
  },
  {
    id: 156,
    name: 'Change shareholder',
    codename: 'de_can_change_shareholder',
    content_type: 77,
  },
  {
    id: 157,
    name: 'Approve shareholder',
    codename: 'de_can_approve_shareholder',
    content_type: 77,
  },
  {
    id: 158,
    name: 'Reject shareholder',
    codename: 'de_can_reject_shareholder',
    content_type: 77,
  },
  {
    id: 159,
    name: 'Return shareholder',
    codename: 'de_can_return_shareholder',
    content_type: 77,
  },
  {
    id: 160,
    name: 'View permissions settings',
    codename: 'de_can_view_permissions_settings',
    content_type: 77,
  },
  {
    id: 161,
    name: 'View permissions',
    codename: 'de_can_view_permissions',
    content_type: 77,
  },
  {
    id: 162,
    name: 'Add permissions',
    codename: 'de_can_add_permissions',
    content_type: 77,
  },
  {
    id: 163,
    name: 'Change permissions',
    codename: 'de_can_change_permissions',
    content_type: 77,
  },
  {
    id: 164,
    name: 'Inactive permissions',
    codename: 'de_can_inactive_permissions',
    content_type: 77,
  },
  {
    id: 165,
    name: 'Filter permissions',
    codename: 'de_can_filter_permissions',
    content_type: 77,
  },

  {
    id: 166,
    name: 'View companies',
    codename: 'de_can_view_companies',
    content_type: 77,
  },
  {
    id: 167,
    name: 'Add companies',
    codename: 'de_can_add_companies',
    content_type: 77,
  },
  {
    id: 168,
    name: 'Filter companies',
    codename: 'de_can_filter_companies',
    content_type: 77,
  },
  {
    id: 169,
    name: 'Inactive companies',
    codename: 'de_can_inactive_companies',
    content_type: 77,
  },

  {
    id: 170,
    name: 'View company profiles',
    codename: 'de_can_view_company_profiles',
    content_type: 77,
  },
  {
    id: 171,
    name: 'Add company profiles',
    codename: 'de_can_add_company_profiles',
    content_type: 77,
  },
  {
    id: 172,
    name: 'Filter company profiles',
    codename: 'de_can_filter_company_profiles',
    content_type: 77,
  },

  {
    id: 173,
    name: 'View company departments',
    codename: 'de_can_view_company_departments',
    content_type: 77,
  },
  {
    id: 174,
    name: 'Add company departments',
    codename: 'de_can_add_company_departments',
    content_type: 77,
  },
  {
    id: 175,
    name: 'Filter company departments',
    codename: 'de_can_filter_company_departments',
    content_type: 77,
  },
  {
    id: 176,
    name: 'Change company departments',
    codename: 'de_can_change_company_departments',
    content_type: 77,
  },

  {
    id: 177,
    name: 'View company groups',
    codename: 'de_can_view_company_groups',
    content_type: 77,
  },
  {
    id: 178,
    name: 'Add company groups',
    codename: 'de_can_add_company_groups',
    content_type: 77,
  },
  {
    id: 179,
    name: 'Filter company groups',
    codename: 'de_can_filter_company_groups',
    content_type: 77,
  }, // corrigido de "filtrar"
  {
    id: 180,
    name: 'Inactive company groups',
    codename: 'de_can_inactive_company_groups',
    content_type: 77,
  },
  {
    id: 181,
    name: 'View company groups details',
    codename: 'de_can_view_company_groups_details',
    content_type: 77,
  },

  {
    id: 182,
    name: 'View company users',
    codename: 'de_can_view_company_users',
    content_type: 77,
  },
  {
    id: 183,
    name: 'Add company users',
    codename: 'de_can_add_company_users',
    content_type: 77,
  },
  {
    id: 184,
    name: 'Filter company users',
    codename: 'de_can_filter_company_users',
    content_type: 77,
  },
  {
    id: 185,
    name: 'Inactive company users',
    codename: 'de_can_inactive_company_users',
    content_type: 77,
  },
  {
    id: 186,
    name: 'View company users details',
    codename: 'de_can_view_company_users_details',
    content_type: 77,
  },
  {
    id: 187,
    name: 'Reset company users',
    codename: 'de_can_reset_company_users',
    content_type: 77,
  },
  {
    id: 188,
    name: 'Change company users',
    codename: 'de_can_change_company_users',
    content_type: 77,
  },
  {
    id: 189,
    name: 'View company users history',
    codename: 'de_can_view_company_users_history',
    content_type: 77,
  },

  {
    id: 190,
    name: 'View company details profiles',
    codename: 'de_can_view_company_details_profiles',
    content_type: 77,
  },
  {
    id: 191,
    name: 'Add company details profiles',
    codename: 'de_can_add_company_details_profiles',
    content_type: 77,
  },
  {
    id: 192,
    name: 'Filter company details profiles',
    codename: 'de_can_filter_company_details_profiles',
    content_type: 77,
  },
  {
    id: 193,
    name: 'Unbound company details profiles',
    codename: 'de_can_unbound_company_details_profiles',
    content_type: 77,
  },

  {
    id: 194,
    name: 'View groups',
    codename: 'de_can_view_groups',
    content_type: 77,
  },
  {
    id: 195,
    name: 'Add groups',
    codename: 'de_can_add_groups',
    content_type: 77,
  },
  {
    id: 196,
    name: 'Filter groups',
    codename: 'de_can_filter_groups',
    content_type: 77,
  },
  {
    id: 197,
    name: 'Inactive groups',
    codename: 'de_can_inactive_groups',
    content_type: 77,
  },
  {
    id: 198,
    name: 'Change groups',
    codename: 'de_can_change_groups',
    content_type: 77,
  },

  {
    id: 199,
    name: 'View my area',
    codename: 'de_can_view_my_area',
    content_type: 77,
  },
  {
    id: 200,
    name: 'desativar perfil',
    codename: 'de_can_inactive_company_profiles',
    content_type: 77,
  },

  {
    id: 201,
    name: 'desativar perfil',
    codename: 'de_can_inactive_company_departments',
    content_type: 77,
  },
];
